import React from "react";
import ReactDom from "react-dom";
import classNames from "classnames";
import PropTypes from "prop-types";
import { CloseIcon } from "../Icons";
import styles from "./index.module.css";

const Modal = ({ visible, children, onToggleVisibility }) =>
  ReactDom.createPortal(
    <div
      className={classNames(
        styles.modal,
        "tw-bg-white tw-fixed tw-top-0 tw-left-0 tw-w-screen tw-min-h-screen tw-flex tw-items-start md:tw-items-center tw-justify-center tw-transition tw-duration-500 tw-ease-in-out tw-transform tw-z-50 tw-font-sans",
        {
          "tw-opacity-0 tw-pointer-events-none tw-scale-125 tw-bg-transparent": !visible
        }
      )}
    >
      <div
        onClick={e => e.stopPropagation()}
        className={classNames(
          "tw-max-w-sm md:tw-max-w-5xl tw-px-4 tw-py-10 ",
          styles.modalContent
        )}
      >
        {children}
      </div>
      <CloseIcon className="tw-cursor-pointer" onClick={onToggleVisibility} />
    </div>,
    document.getElementById("gw-search-modal")
  );

Modal.propTypes = {
  visible: PropTypes.bool.isRequired,
  children: PropTypes.any
};

export default Modal;
